import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

const Users = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)
    const [sortOrder, setSortOrder] = useState('asc')
    const [usersPending, setUsersPending] = useState(false)
    const [totalUsers, setTotalUsers] = useState(0)
    // const [makingAmbassador, setMakingAmbassador] = useState(false)
    const [showAmbassadors, setShowAmbassadors] = useState(false);

    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationSubject, setNotificationSubject] = useState("");
    const [notificationSending, setNotificationSending] = useState(false);
    const [ambassadorDuration, setAmbassadorDuration] = useState("");
    const [ambassadorAmount, setAmbassadorAmount] = useState("");
    const [searchString, setSearchString] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const sortedUsers = sortOrder === 'asc' ? [...users] : [...users].reverse();
    // console.log(totalUsers);
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedUsers.slice(indexOfFirstItem, indexOfLastItem);

    // Create an instance of Axios
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const viewUser = (index) => {
        // const clickedObject = products[index];
        setSelectedUser(users[index])
        console.log("index clicked:" + index)
        console.log(selectedUser)
    }
    const handleNotificationContentChange = (event) => {
        setNotificationMessage(event.target.value);
    };

    const handleSubmitNotification = (event) => {
        event.preventDefault();
        if (notificationMessage.trim() === "") {
            // Handle empty content case
            return;
        }
        setNotificationSending(true);
        api
            .post(`${base_url}/notification/add/${selectedUser.userID}`, {
                subject: notificationSubject,
                message: notificationMessage,
            })
            .then((response) => {
                // Handle successful response, e.g., show a succes  s message
            })
            .catch((error) => {
                // Handle error, e.g., show an error message
                addNotificationError("An error occurred and your notification wasnt added.")
            })
            .finally(() => {
                setNotificationSending(false);
                setNotificationMessage("");
                addNotificationSuccess("Notification was successsfully created")
            });
    };

    const fetchData = async () => {
        try {
            setUsersPending(true)
            const response = await api.get(`${base_url}/user/user-by-page/10/${currentPage}`);
            setUsers(response.data.jointObject);
            setUsersPending(false)
            // console.log(users)
        } catch (error) {
            console.log(error);
            // deleteUserError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    const descFetchData = async () => {
        try {
            setUsersPending(true)
            const response = await api.get(`${base_url}/user/user-by-page/10/${currentPage}`);
            setUsers(response.data.jointObject);
            setUsersPending(false)
            // console.log(users)
        } catch (error) {
            console.log(error);
            // deleteUserError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    const makeUserAnAmbassador = async (email) => {
        try {
            

            api
            .post(`${base_url}/notification/add/${selectedUser.userID}`, {
                email: email,
                subject: ambassadorDuration,
                message: ambassadorAmount,
            })
            .then((response) => {
                // Handle successful response, e.g., show a succes  s message
                
                console.log("User has been successfully made an ambassador")
            })
            .catch((error) => {
                // Handle error, e.g., show an error message
                addNotificationError("An error occurred and your request was not successful.")
            });
            

            
            // console.log(users)
        } catch (error) {
            console.log(error);
            // deleteUserError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    // const fetchAllUsers = async () => {
    //     try {
    //         const response = await api.get(`${base_url}/user/all-users`);
    //         setAllUsers(response.data.users);
    //         console.log(allUsers)
    //     } catch (error) {
    //         console.log(error);
    //         // deleteUserError("An error occured while trying to delete entry. Try again or contact support")
    //     }
    // };

    useEffect(() => {
        fetchData();
        // fetchAllUsers();

        //check total users
        api.get(`${base_url}/user/total-users/all`)
            .then(function (response) {
                // console.log(response.data)
                setTotalUsers(response.data.users)
            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                } else {
                    console.log("An error occurred")
                }
            })
    }, [currentPage]);

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const toggleShowAmbassadors = () => {
        setShowAmbassadors(!showAmbassadors); 
    };

    const addNotificationSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
    const addNotificationError = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(totalUsers / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(totalUsers / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(totalUsers / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };

    const handleSearchInputChange = async (event) => {
        const searchString = event.target.value;
        setSearchString(searchString);
        if (searchString.trim() === "") {
            setSearchResults([]);
            return;
        }
        try {
            const response = await api.get(`${base_url}/user/search/${searchString}`);
            setSearchResults(response.data.searchResults);
        } catch (error) {
            console.log(error);
        }
    };


    // end navigation options
    return (
        <>
            <div>
                {/* <ToastContainer /> */}
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi bi-person"></i> ALL USERS <small className="text-secondary" style={{ fontWeight: "400", fontSize: "smaller" }}>({totalUsers})</small>
                        </h6>
                    </div>
                    
                    <div className="d-flex justify-content-end align-items-center flex-fill text-end">

                    <div className="input-group ms-1" style={{ width: '250px' }}>
        <input
            type="text"
            className="form-control custom-input-group"
            placeholder="Search users..."
            value={searchString}
            onChange={handleSearchInputChange}
        />
    </div>

                    <button className="btn-custom ms-1" onClick={toggleShowAmbassadors}>
                        {showAmbassadors ? 'Show All' : 'Show Ambassadors Only'}
                    </button>

                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>Names</th>
                                <th>Email</th>
                                <th>Tel</th>
                                <th>Creation date</th>
                                <th>Is Ambassador</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        {/* <tbody>
                            {
                                usersPending ? (
                                    <tr>
                                        <td colSpan="5" className="text-center my-">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    users.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.fullName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.phonenumber}</td>
                                            <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>Nil</td>
                                            <td>
                                                <button className="btn-custom-sm" data-bs-toggle="modal" data-bs-target="#view-user" onClick={() => viewUser(index)}>
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )
                            }
                        </tbody> */}
                        <tbody>
    {usersPending ? (
        <tr>
            <td colSpan="5" className="text-center my-">
                <div className="spinner-border spinner-border-lg text-custom my-3"></div>
            </td>
        </tr>
    ) : (
        (searchResults.length > 0 ? searchResults : users).map((item, index) => {
            // Check if the user is an ambassador and the filter is active
            if (showAmbassadors && !item.isAmbassador) {
                return null; // Skip rendering this row
            }
            return (
                <tr key={index}>
                    <td>{item.fullName}</td>
                    <td>{item.email}</td>
                    <td>{item.phonenumber}</td>
                    <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                    <td>{item.isAmbassador ? 'Yes' : 'No'}</td>
                    <td>
                        <button className="btn-custom-sm" data-bs-toggle="modal" data-bs-target="#view-user" onClick={() => viewUser(index)}>
                            View
                        </button>
                    </td>
                </tr>
            );
        })
    )}
</tbody>
                    </table>
                </div>

                <div className="pagination btn-group">
                {searchResults.length === 0 && totalUsers > itemsPerPage && (
                        <>
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>

                    {/* page numbered buttons */}
                    {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(totalUsers / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(totalUsers / itemsPerPage)}
                    >
                        Last
                    </button>
                    </>
                    )}
                </div>

            </div>

            {/* Modal data content */}
            <div className="modal fade" id="view-user">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-person"></i> User Information</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="col-12">
                                    <h4 className="text-custom">{selectedUser.fullName}</h4>
                                    <dl>
                                        <dt></dt>
                                        <dd></dd>
                                    </dl>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt>User ID</dt>
                                            <dd>{selectedUser.userID}</dd>

                                            <dt>Corper Invest ID</dt>
                                            <dd>{selectedUser.corperInvestID}</dd>

                                            <dt>Email</dt>
                                            <dd>{selectedUser.email}</dd>

                                            <dt>Phone Number</dt>
                                            <dd>{selectedUser.phonenumber}</dd>

                                            <dt>Account Type</dt>
                                            <dd>{selectedUser.corperInvestType}</dd>

                                            <dt>BVN</dt>
                                            <dd>{selectedUser.BVN}</dd>

                                            <dt>Creation Date</dt>
                                            <dd>{moment(selectedUser.createdAt).format('DD MMM YYYY h:mm:ss a')}</dd>
                                        </dl>
                                    </div>
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt>Registeration status</dt>
                                            <dd>{selectedUser.isRegistrationCompleted ? (<>Completed</>) : (<>Not Completed</>)}</dd>

                                            <dt>Documents status</dt>
                                            <dd>{selectedUser.isUploadDocCompleted ? (<>Uploaded</>) : (<>Not Uploaded</>)}</dd>

                                        </dl>
                                        <form onSubmit={makeUserAnAmbassador(selectedUser.email)}>
                                            <div className="mb-3">
                                                <label htmlFor="notificationContent" className="form-label bold">Make User An Ambassador</label>
                                                <div className="input-group my-1">
                                                    <input type="text" className="form-control custom-input-group" value={ambassadorDuration} onChange={(e) => setAmbassadorDuration(e.target.value)} placeholder="Duration" required />
                                                </div>
                                                <div className="input-group my-1">
                                                    <input type="text" className="form-control custom-input-group" value={ambassadorAmount} onChange={(e) => setAmbassadorAmount(e.target.value)} placeholder="Amount" required />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn-custom" disabled={ambassadorAmount}>
                                                 Make User An Ambassador
                                            </button>
                                        </form>
                                        <form onSubmit={handleSubmitNotification}>
                                            <div className="mb-3">
                                                <label htmlFor="notificationContent" className="form-label bold">Notification</label>
                                                <div className="input-group my-1">
                                                    <span class="input-group-text input-group-text-custom"><i class="bi-info-circle"></i></span>
                                                    <input type="text" className="form-control custom-input-group" value={notificationSubject} onChange={(e) => setNotificationSubject(e.target.value)} placeholder="Subject" required />
                                                </div>
                                                <textarea
                                                    id="notificationContent"
                                                    className="form-control  custom-input-group"
                                                    rows="3"
                                                    value={notificationMessage}
                                                    onChange={handleNotificationContentChange}
                                                    placeholder="Content"
                                                />
                                            </div>
                                            <button type="submit" className="btn-custom" disabled={notificationSending}>
                                                {notificationSending ? "Sending..." : "Send Notification"}
                                            </button>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* <!-- Modal footer --> */}
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
            {/* End modal data content */}
        </>
    );
};

export default Users;

